
$(function(){
    
    // Hero slider

    let currentSlideColor;

    $('#hero-slider').on('init', function(event, slick){

        let bgColor = $(slick.$slides.get(0)).attr('data-background-color');
    
        let bgStyle = $(slick.$slides.get(0)).attr('data-background-style');
    
        $('.site-header').removeClass(currentSlideColor);
    
        currentSlideColor = bgColor;
    
        $('.site-header').addClass(bgColor);
    
        if (bgColor == 'green' || bgColor == 'red' || bgColor == 'gray') {
    
            $('.site-header').addClass("white-header");
    
        } else {
    
            $('.site-header').removeClass("white-header");
    
        }
    
        if (bgStyle == 'style-100') {
    
            $('.site-header').addClass("style-100");
    
        } else {
    
            $('.site-header').removeClass("style-100");
    
        }
    
    });

    $('#hero-slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: false,
        fade: true,
        appendDots: '.hero-section .controls',
        autoplay: true,
        autoplaySpeed: 8000,
    });
    
    $('#hero-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    
        let bgColor = $(slick.$slides.get(currentSlide)).attr('data-background-color');
    
        let bgStyle = $(slick.$slides.get(currentSlide)).attr('data-background-style');
    
        $('.site-header').removeClass(currentSlideColor);
    
        currentSlideColor = bgColor;
    
        $('.site-header').addClass(bgColor);
    
        if (bgColor == 'green' || bgColor == 'red' || bgColor == 'gray') {
    
            $('.site-header').addClass("white-header");
    
        } else {
    
            $('.site-header').removeClass("white-header");
    
        }
    
        if (bgStyle == 'style-100') {
    
            $('.site-header').addClass("style-100");
    
        } else {
    
            $('.site-header').removeClass("style-100");
    
        }
    
    });
    
    $(".catalog-collection-product-slider").each(function () {
        $(this).slick({
            dots: true,
            infinite: false,
            slidesToShow: 3,
            speed: 800,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: '<button class="prev-slider"><svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" transform="matrix(-1 0 0 1 64 0)" fill="#3D4246"/><path d="M34.3333 24L26.3333 32L34.3333 40" stroke="#FFF4F4"/></svg></button>',
            nextArrow: '<button class="next-slider"><svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" fill="#3D4246"/><path d="M29.6667 24L37.6667 32L29.6667 40" stroke="#FFF4F4"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                }
            ]
        });
    });
    
    $(".our-brands-slider").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 800,
        adaptiveHeight: false,
        centerMode: false,
        variableWidth: false,  
        arrows: true,
        prevArrow: '<button class="prev-slider"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" rx="24" transform="matrix(-1 0 0 1 48 0)" fill="black" fill-opacity="0.2"/><path d="M25 18L19 24L25 30" stroke="#FFF4F4"/></svg></button>',
        nextArrow: '<button class="next-slider"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" rx="24" fill="black" fill-opacity="0.2"/><path d="M23 18L29 24L23 30" stroke="#FFF4F4"/></svg></button>',
        appendArrows: $('#our-brands-section .controls'),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    });

    $(".product-slider").each(function () {
        $(this).slick({
            dots: true,
            infinite: false,
            slidesToShow: 3,
            speed: 800,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: '<button class="prev-slider"><svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" transform="matrix(-1 0 0 1 64 0)" fill="#3D4246"/><path d="M34.3333 24L26.3333 32L34.3333 40" stroke="#FFF4F4"/></svg></button>',
            nextArrow: '<button class="next-slider"><svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" fill="#3D4246"/><path d="M29.6667 24L37.6667 32L29.6667 40" stroke="#FFF4F4"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        arrows: false
                    }
                }
            ]
        });
    });

        $(".product-detail-gallery-slider").each(function () {
        $(this).slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: false
        });
    });
    
    // Mega menu behaviour
    
    $(".second-level").hover(function(){
        $(".second-level").removeClass("active");
        $(this).addClass("active");
    
    }, function(){
        $(".second-level:nth-child(1)").addClass("active");
    });
    
    
    // $(window).scroll(function () {
    //     if($(window).scrollTop() > 800) {
    //       $(".site-header").addClass('sticky');
    //     } else {
    //       $(".site-header").removeClass('sticky');
    //     }
    //   });

  $(window).scroll(function () {
    // Check if the current URL does not include '/blogs/a-la-mod/'
    if (window.location.href.indexOf("/blogs/a-la-mod/") === -1) {
        // If the URL doesn't contain '/blogs/a-la-mod/', apply the sticky header behavior
        if ($(window).scrollTop() > 800) {
            $(".site-header").addClass('sticky');
        } else {
            $(".site-header").removeClass('sticky');
        }
    }
});


    $(".site-nav > .site-nav--has-dropdown").hover(function(){
        $(".site-header").addClass("dropdown-open");
    }, function(){
        $(".site-header").removeClass("dropdown-open");
    });

    // Zoom functionality

    let currentImage = $('#productSlider .slick-current img').attr('zoom-src');

    $(".zoom-button").attr('href', currentImage);

    $('#productSlider').on('afterChange', function(){

        currentImage = $('#productSlider .slick-current img').attr('zoom-src');


        $(".zoom-button").attr('href', currentImage);

    });

    // Mobile menu

//   document.addEventListener('DOMContentLoaded', function() {
//   const mobileMenuTrigger = document.querySelector('.js-mobile-nav-toggle');
//   const mobileNav = document.querySelector('.site-header__mobile-nav');

//   if (mobileMenuTrigger && mobileNav) {
//     mobileMenuTrigger.addEventListener('click', function() {
//       setTimeout(() => {
//         const menuIsOpen = document.body.classList.contains('js-menu--is-open') || mobileMenuTrigger.getAttribute('aria-expanded') === 'true';
//         if (menuIsOpen) {
//           mobileNav.classList.add('fixed-position');
//         } else {
//           mobileNav.classList.remove('fixed-position');
//         }
//       }, 50); // short delay to ensure menu state updates
//     });
//   }
// });


    // $(".mobile-nav__link").click(function(){
    //     $(".mobile-nav__link").removeClass("is-active");
    //     $(this).addClass("is-active");

    //     // Mega menu slider

    //     $(".slider-in-mega-menu").each(function () {
    //         $(this).slick({
    //             dots: true,
    //             infinite: false,
    //             speed: 300,
    //             slidesToShow: 2,
    //             slidesToScroll: 2,
    //             adaptiveHeight: false,
    //             arrows: false
    //         });
    //     });

    // });

    // Read More

    $readMoreJS({
        // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.').
        target: '.description.read-more-less', 
        // Number of words to initially display (any number). 
        wordsCount: 44,     
        // If true, user can toggle between 'read more' and 'read less'. 
        toggle: true,              
        // The text of 'Read more' link. 
        moreLink: 'Read more', 
        // The text of 'Read less' link. 
        lessLink: ' Read less',      
        // The class given to the read more link. 
        linkClass: 'read-more-link',    
      });

});





